import { render } from "./AlarmsPage.vue?vue&type=template&id=31d8e94f&scoped=true&ts=true"
import script from "./AlarmsPage.vue?vue&type=script&lang=ts"
export * from "./AlarmsPage.vue?vue&type=script&lang=ts"

import "./AlarmsPage.vue?vue&type=style&index=0&id=31d8e94f&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d8e94f"]])

export default __exports__